module.exports = __webpack_public_path__ + "media/images/weather/83_night_g-0b410a6191e8a91bf2efe1789da714b3.png";